import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { ReferralFilterOptions } from '@core/referrals-types';

import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<ReferralFilterOptions | null>()(EntityStoreKey.offerFilters);

export {
  actions as OfferFiltersActions,
  reducer as offerFiltersReducer,
  selectors as offerFiltersSelectors,
  namespace as OfferFiltersNamespace,
};
